// extracted by mini-css-extract-plugin
export default {"card":"styles-module__card__src-labstep-web-core-PremiumFeature-ScreenGuard-_mP9Np"};